import OnboardingGilroyFace from 'Components/common/assets/svgIcons/OnboardingGilroyFace';
import {
  maxMobile,
  maxTablet,
  maxWidth,
  primaryHeadingColor, retina, secondaryFont, wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import HTMLReactParser from 'html-react-parser';
import React from 'react';
import styled from 'styled-components';

const StyleWrapper = styled.div`
.welcome-message-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 758px;
  height: calc(100vh - 234px); //useref se set krna bad me 
  @media all and (max-width: ${maxWidth}), ${retina} {
    width: 625px;
  }
  @media all and (max-width: ${maxTablet}) {
    width: 300px;
    margin: 0 auto;
  }
  @media all and (max-width: ${maxMobile}) {
    width: 305px;
  }
  .onboarding-gilroy-face-svg {
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: 70px;
      height: 57px;
      flex-shrink: 0;
    }
    @media all and (max-width: ${maxTablet}) {
      width: 62px;
      height: 49px;
    }
  }
  .onboarding-gilroy-fire-work-svg {
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: 86px;
      height: 80px;
    }
  }
  .welcome-message {
    color: ${primaryHeadingColor};
    font-family: ${secondaryFont};
    font-size: 30px;
    font-weight: ${wMedium};
    line-height: 35px;
    letter-spacing: -0.75px;
    margin-bottom: 0;
    margin-top: 32px;
    text-align: center;
    sup {
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 16px;
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 12px;
      top: -9px;
    }
    }
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 24px;
      line-height: 30px;
      margin-top: 24px;
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 20px;
      line-height: 24px;
    }
  }
}
`;
type Props = {
  emoji?: object,
  firstText?: string,
  middleText?: string,
  lastText?: string,
} & typeof defaultProps;

const defaultProps = {
  emoji: <OnboardingGilroyFace />,
  firstText: '',
  middleText: '',
  lastText: '',
};

const WelcomeScreen = function WelcomeScreen(props: Props) {
  const {
    firstText, middleText, lastText, emoji,
  } = props;
  return (
    <StyleWrapper className={classNames('welcome-screen-style-wrapper')}>
      <div className="welcome-message-div">
        {emoji}
        <p className="welcome-message">
          {HTMLReactParser(firstText)}
          {middleText ? (<span className="primary-color"> Go beyond the profile </span>) : null}
          {HTMLReactParser(lastText)}
        </p>
      </div>
    </StyleWrapper>
  );
};
WelcomeScreen.defaultProps = defaultProps;
export default WelcomeScreen;
